export const Step = {
  INITAL: 1,
  CURRENCY: 2,
  NOTE: 3,
  PAYMENT_METHOD: 4,
  CATEGORIES: 5,
  SUB_CATEGORIES: 6,
  COST_CENTER: 7,
  BUDGET: 8,
  VENDOR: 9,
  AMOUNT: 11,
  EXCHANGE_RATE: 12,
  VENDOR_PAYMENT_DETAILS: 13,
} as const;
